<!--
 * @Author: gongzhichao
 * @Date: 2023-05-10 17:33:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 列表公共页面
-->
<template>
  <div class="main">
    <SecondPage>
                <!-- 标签切换区域 -->
                <div class="tab-buttons">
              <button 
                v-for="btn in  $config.dataInfoList" 
                :key="btn.selectType" 
                @click="toggleTab(btn.selectType)" 
                :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
              >
                  <div  :class="'tab-title'+ btn.tab">{{ btn.title }}</div>
                      <img
                        :src="btn.backgroundImg"
                        alt=""
                        :class="'people-tab' + btn.tab"
                      />
        </button>
        </div>
      <div class="announcement-content">
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="getNewsOftype">
            <el-tab-pane label="最新" name="all"></el-tab-pane>
            <el-tab-pane label="公告" name="0"></el-tab-pane>
            <el-tab-pane label="活动" name="2"></el-tab-pane>
            <el-tab-pane label="攻略" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list" v-loading="loading">
          <div
            class="list-item"
            v-for="item in newList.slice(0, 15)"
            :key="item.id"
          >
            <div class="info">
              <img
                src="../../../assets/image/pc/list-icon.png"
                alt="公告图标"
              />
              <a @click="redirectPage({ path: title, ...item })">{{
                item.title
              }}</a>
              <!-- <a>{{ item.title }}</a> -->
            </div>
            <div class="date">
              {{ $moment(item.createTime).format("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <div class="mypagination">
          <el-pagination
            small
            hide-on-single-page
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="15"
            :total="pageTotel"
            layout="total, prev, pager, next"
          ></el-pagination>
        </div>
      </div>
    </SecondPage>
    <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SecondPage from "../component/SecondPage/SecondPage.vue";
import webSite from "../../../api/webSite";
import webSiteHigh from "../../../api/webSiteHigh";
import webSiteThree from "../../../api/webSiteThree";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { SecondPage },

  computed: {
    ...mapGetters({
      articlesList: "base/articlesList",
    }),
    // 列表
    list() {
      let { announcementList, preserveList } = JSON.parse(
        localStorage.getItem("store")
      );
      const objKey = {
        announcementList: "官网公告",
        preserveList: "更新维护",
      };
      const objList = {
        announcementList,
        preserveList,
      };
      let keys = Object.keys(objKey);
      let values = Object.values(objKey);
      let key = keys[values.indexOf(this.$route.query.title)];
      return objList[key];
    },
  },
  data() {
    return {
      loading: false,
      showVisible:false,
      pageTotel: 0,
      currentPage: 1,
      activeName: "all",
      currentTab: '',
      newList: [],
      newListPro: [],
    };
  },
  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },

  mounted() {
    this.getNewsOftype({ label: "最新" });
    this.toggleTab();
  },
  methods: {
    ...mapActions({
      getAllNews: "base/getAllNews",
    }),
             // 切换标签
      // 切换标签
    toggleTab(tab) {
      this.getNewsOftype({ label: "最新" });
      this.activeName="最新"
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');
      if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
        this.getNewsOftype({ label: "最新" });
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
        this.getNewsOftype({ label: "最新" });
      } else {
         this.currentTab="official"
         this.getNewsOftype({ label: "最新" });
        // 其他 tab 的处理逻辑
      }
    },
    // 页面跳转
    async redirectPage(item) {
      let { id, title } = item;
      this.$router.push({
        path: "/detail",
        query: { id, title, path: "公告咨询" },
      });
    },
        // 获取文章
   async   getNewsOftype(tab) {
      const storedValue = sessionStorage.getItem('toggleTab');

      if(storedValue === 'threeExplosive'){
        let arr = [];
      const type = tab.name;
      switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteThree.getAllNews(newsType);
                arr=res.data ;
                break;
              }
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteThree.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;

      }else if(storedValue === 'highExplosive'){
        let arr = [];
      const type = tab.name;
      switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteHigh.getAllNews(newsType);
                arr=res.data ;
                break;
              }
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteHigh.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;

      }else{
        let arr = [];
       const type = tab.name;
       switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSite.getAllNews(newsType);
                arr=res.data ;
                break;
              }
          default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSite.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;
      }

    },
    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      setTimeout(() => {
        this.newList = this.newListPro.slice((val - 1) * 15, val * 15);
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
   .tab-buttons {
  display: flex;
  gap:8px; /* 按钮之间的间距 */
  justify-content: center; /* 按钮居中显示 */
  margin-top: 35px;
  margin-bottom: 20px;
  padding: 0 10px;
}

.tab-button {
  /* 基础按钮样式，确保文字居中 */
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight:400;
  color: #704c13;
  padding: 8px 12px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;
  outline: none;
  flex: 1;
  max-width: 110px;

  /* 移除默认按钮样式 */
  &:focus {
    outline: none;
  }
}

// 默认状态样式
.item-def {
  background-image: url("../../../assets/image/pc/basemap-data-def.png");
  /* 根据实际图片尺寸调整按钮大小 */
  width: 100%;
  height: 50px;

}

// 激活状态样式
.item-active {
  background-image: url("../../../assets/image/pc/basemap-data-active.png");
  color: #f4f7f6; /* 激活状态文字颜色 */

  width:100%;
  height: 50px;
}
.tab-title1{
  width: 100%;
  font-size: 13px;
  text-align: center;
}
.tab-title2{
    width: 100%;
    height: 20px;
    font-size: 13px;
    margin-left: -16px;
}
.tab-title3{
  width: 100%;
  font-size: 13px;
  text-align: center;
}
.tab-button .people-tab1 {
  width: 60px;
 height: 60px;
  position: relative;
  margin-left: -117%;
  margin-top: -70%;
}

.tab-button .people-tab2 {
  width:60px;
  height: 70px;
  position: relative;
  margin-top: -95%;
  margin-left: 52%;
}
.tab-button .people-tab3 {
  width: 60px;
 height: 60px;
  position: relative;
  margin-left: -117%;
  margin-top: -70%;
}
.announcement-content {
  .tab {
    display: flex;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #000;

    /deep/ .el-tabs__header {
      height: 50px;
      margin: 0;
      margin-left: 15px;
    }
    /deep/.el-tabs__nav-scroll {
      height: 50px;
    }

    /deep/ .el-tabs__nav {
      height: 50px;
    }

    /deep/ .el-tabs__item {
      height: 50px;
      line-height: 50px;
    }
    /deep/.el-tabs__active-bar {
      background-color: #745934;
    }
    /deep/ .el-tabs__item:hover {
      color: #ff913d;
    }
    /deep/ .el-tabs__item.is-active {
      color: #ff913d;
    }

    p {
      width: 67px;
      height: 50px;
      text-align: center;
      line-height: 50px;
    }
  }
  .list {
    .list-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      font-size: 12px;
      cursor: pointer;
      .info {
        display: flex;
        align-items: center;
        flex: 4;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        img {
          margin-right: 5px;
        }
      }
      .date {
        flex: 2;
      }
    }
  }
  .mypagination {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    /deep/ .el-pagination__total {
      font-size: 26px;
    }
    /deep/ .el-pagination button {
      width: 20px;
      height: 20px;
      background: transparent;
    }
    /deep/ .el-pagination span {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
    }

    /deep/ .el-pagination .el-pager li {
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: transparent;
    }

    /deep/ .el-pager li.active {
      color: #643e22;
    }

    /deep/ .el-pagination button:disabled {
      background: transparent;
      span {
        color: #643e22;
        font-weight: 700;
      }
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #643e22;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #643e22;
    }
  }
}
</style>
